export default "__VITE_ASSET__BseHSDCy__"